import React from "react";
import Button from "@material-ui/core/Button";
import { downloadMissionSchema } from "components/utils";
import HiddenOn from "components/common/HiddenOn";
import Typography from "@material-ui/core/Typography";
import styled from "styled-components";

export const EventHeaderActionPanel = ({
  handleClick,
  isMobile,
  userIsOwner,
  redirect,
  id,
  eventTitle,
  currentEvent,
}) => {
  return (
    <ButtonContainer isMobile={isMobile}>
      <Typography variant="h5" component="h5">
        <u>
          <b>ACTIONS</b>
        </u>
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          handleClick({ message: "Copied misson link to clipboard." });
          navigator.clipboard.writeText(window.location.href);
        }}
      >
        Copy Mission Link
      </Button>
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          handleClick({ message: "Copied reserve command to clipboard." });
          navigator.clipboard.writeText(`!reserve ${id}`);
        }}
      >
        Copy Reserve command
      </Button>
      <div>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            handleClick({
              message: "Schema download started. Check your downloads folder.",
            });
            downloadMissionSchema({ currentEvent, eventTitle });
          }}
        >
          Download Schema
        </Button>
        <HiddenOn hideOn={!userIsOwner}>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => redirect(`/edit/${id}`)}
          >
            Edit Mission
          </Button>
        </HiddenOn>
      </div>
    </ButtonContainer>
  );
};

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  & Button {
    margin: 10px;
  }
  > div {
    display: flex;
    > button {
      flex-grow: 1;
    }
  }
`;

export default EventHeaderActionPanel;
